export enum AccessLevel {
  Cleaner = 'cleaner',
  SuperUser = 'superUser',
  Admin = 'admin',
  None = 'none',
}
